/**
 * Formats an ISO timestamp for chat bubbles (local time, friendly labels).
 * @param {string | undefined} iso
 * @returns {string}
 */
export function formatChatTimestamp(iso) {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''

  const now = new Date()
  const time = date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  })

  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear()

  const yesterday = new Date(now)
  yesterday.setDate(now.getDate() - 1)
  const isYesterday =
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear()

  if (isToday) return time
  if (isYesterday) return `Yesterday, ${time}`
  return `${date.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
  })}, ${time}`
}
